export const formatREACardData = (reaArr, type, isMobile) => {
    for (let rea of reaArr) {
        if (type === 'compliance') {
            rea.url = isMobile ? '/compliance-report-agent-detail-mobile' : '/compliance-report-agent-detail';
            rea.url = rea.url + '?id=' + rea.uid + "&isCompliance=1&isAgent=true";
        } else if (type === 'learningprogress') {
            rea.url = isMobile ? '/compliance-report-agent-detail-mobile' : '/compliance-report-agent-detail';
            rea.url = rea.url + '?id=' + rea.uid + "&isCompliance=0&isAgent=true";
        }
    }
    return reaArr;
}

// const commentReportSort = () => {
    // {false && 
    //     <section className="report-graphname">
    //         <div className="container">
    //             <div className="row">
    //                 <div className="col-md-12">
    //                     <div className="report-graph-trend">
    //                         <div className="input-text fliterreportsgen graphselct mb-0">
    //                             <label for="filter" className="input__label">Select Year</label>
    //                             <select type="text" id="filter" name="filter" className="form-select input_searchfield mb-0 session-filter"
    //                                 onChange={(e) => {
    //                                     const selectedYear = e.target.value;
    //                                     setTrendYear(selectedYear)
    //                                     setImgLoader(true)
    //                                 }}
    //                             >
    //                                 {filterYearData?.map((item, index) => {
    //                                     return (
    //                                         <option seleted key={index} value={item[index]}
    //                                         >{item}</option>
    //                                     )
    //                                 })}
    //                             </select>
    //                         </div>
    //                         {imgLoader ? (
    //                             <div className="d-flex justify-content-center w-100">
    //                                 <Spinner animation="border" />
    //                             </div>
    //                         ) : (
    //                             <div className="d-flex justify-content-start gap-5 mob-res w-100">
    //                                 <CompletionTrendGraph
    //                                     crsCompltTrendData={crsCompltTrendValues}
    //                                     completionTrendLabel={"Compliance Courses Completion"}
    //                                     crsCompltTrend={filterYearData}
    //                                     setTrendYear={setTrendYear}
    //                                     trendYear={trendYear}
    //                                     setImgLoader={setImgLoader}
    //                                     setLoaderChart={setLoaderChart}
    //                                     loaderChart={loaderChart}
    //                                 />
    //                             </div>
    //                         )}
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>
    //     </section>
    //     }
// }